import { render } from "./WarningSign.vue?vue&type=template&id=46360ad4&scoped=true"
import script from "./WarningSign.vue?vue&type=script&lang=js"
export * from "./WarningSign.vue?vue&type=script&lang=js"

import "./WarningSign.vue?vue&type=style&index=0&id=46360ad4&scoped=true&lang=css"

import exportComponent from "/tmp/build_642e477e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46360ad4"]])

export default __exports__